// @flow weak

import PropTypes from 'prop-types';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import z from 'app/common/z';
import { legacyFooterId, legacyHeaderId } from 'app/legacy/LegacyUtils';

const getHeaderElement = () => document.getElementById(legacyHeaderId);
const getFooterElement = () => document.getElementById(legacyFooterId);

const RefreshChrome = createReactClass({
  displayName: 'RefreshChrome',

  propTypes: {
    // Just so we can keep RefreshChrome even when we don't need it so it doesn't mount/unmount.
    shouldPassThrough: PropTypes.bool,
    children: PropTypes.any,
  },

  getDefaultProps() {
    return {
      shouldPassThrough: false,
    };
  },

  getInitialState() {
    return {
      hasChrome: Boolean(getHeaderElement()) && Boolean(getFooterElement()),
    };
  },

  // Might be some extra nodes from the server. Yank them.
  clearExtraNodes(node) {
    if (!node || node.id === 'react-root-app') {
      return;
    }
    const nextSibling = node.nextSibling;
    if (_.isFunction(node.remove)) {
      node.remove();
    } else {
      // Okay, IE, I'm looking at you.
      node.parentNode.removeChild(node);
    }
    this.clearExtraNodes(nextSibling);
  },

  setHasChrome() {
    this.setState({ hasChrome: true });
  },

  UNSAFE_componentWillMount() {
    this.refreshChrome();
  },

  componentDidUpdate() {
    this.refreshChrome();
  },

  // This is mucho silly. But we now have two ways of doing the header. One is
  // the old way and is used most everywhere. The other way is inside a new
  // `static-content` div. This is a special ugly hack to remove that section.
  // We really should just have one way of doing the header!!! This whole
  // component was a hack to begin with. Now we have a hack on top of our hack.
  removeStaticContent() {
    const staticNode = document.getElementById('static-content');
    if (staticNode) {
      if (_.isFunction(staticNode.remove)) {
        staticNode.remove();
      } else {
        if (staticNode.parentNode) {
          staticNode.parentNode.removeChild(staticNode);
        }
      }
    }
  },

  refreshChrome() {
    if (!this.props.shouldPassThrough) {
      this.removeStaticContent();

      if (!this.state.hasChrome) {
        z.useful.refreshChrome({
          success: () => {
            this.setHasChrome();
          },
          error: err => {
            console.error('Unable to refresh chrome!!!', err);

            // Because `/chrome.html` can return a `403` error, this means that
            // it is possible for a user logging in using 2FA to encounter a
            // `403` response from `/chrome.html` when they have not provided
            // their authentication code. However, the login page doesn't need
            // to make this request in order to render. By allowing this to
            // perform `this.setHasChrome` it will allow the UI to continue
            // rendering
            if (err && err.status === 403) {
              this.setHasChrome();
            }
          },
        });
      } else {
        const headerNode = getHeaderElement();
        if (headerNode) {
          this.clearExtraNodes(headerNode.nextSibling);
        }
      }
    }
  },

  render() {
    if (this.props.shouldPassThrough || this.state.hasChrome) {
      return this.props.children;
    } else {
      return null;
    }
  },
});

export default RefreshChrome;
